<!--
  This is the component for user menu options in the app's sidebar.
  The option to go to "My Profile" will direct the user to their profile page based on their user role.

  @Author: Andrew Gunter
-->

<template>
  <div class="user">
    <div class="photo">
      <img :src="profilePicture" class="ociUserIcon"/>
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" href="#">
           <span>
             {{name}}
             <b class="caret"></b>
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav" style="margin-top:10px" v-show="!isClosed">
            <router-link
              tag="li"
              :to="{ path: this.profilePagePath}">
              <a class="nav-link">
                <span class="sidebar-mini-icon">MP</span>
                <span class="sidebar-normal">My Profile</span>
              </a>
            </router-link>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import {CollapseTransition} from 'vue2-transitions';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      CollapseTransition
    },
    props: {
      title: {
        type: String,
      },
    },
    data() {
      return {
        isClosed: true
      }
    },
    computed: {
      ...mapGetters([
        'appUser'
      ]),
      profilePagePath: {
        get() {
          let role;
          if(this.appUser.isSuper){
            role = "admin";
          }
          if(this.appUser.isOciBroker){
            role = "broker";
          }
          if(this.appUser.isPartner){
            role = "partner";
          }
          if(this.appUser.isDeveloper){
            role = "developer";
          }
          if(this.appUser.isLender){
            role = "lender";
          }
          return "/" + role + "/profile";
        }
      },
      profilePicture: {
        get() {
          if (this.$store.getters.profilePicture) {
            return this.$store.getters.profilePicture;
          }
        }
      },
      name: {
        get() {
          if (this.$store.getters.appUser) {
            return this.$store.getters.appUser.firstName + " " + this.$store.getters.appUser.lastName;
          }
          else {
            return "";
          }
        }
      }
    },
    methods: {
      toggleMenu() {
        this.isClosed = !this.isClosed
      },
    },
    mounted() {
    },
  }
</script>
<style>
  .ociUserIcon {
    display: inline-block;
    border-radius: 60px;
    box-shadow: 0px 0px 2px #888;
  }
</style>
